import { Component, Input, Output, EventEmitter } from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {
    SectionNavModel
} from "@white-label/components/page-builder/layout/section-parts/add-sections-configuration.model";

@Component({
    selector: 'white-label-section-selector',
    templateUrl: './white-label-section-selector.component.html',
    imports: [
        NgForOf,
        NgIf
    ],
    standalone: true
})
export class WhiteLabelSectionSelectorComponent {
    @Input() index: number = 0;
    @Output() openType = new EventEmitter <{ type: string; subType?: string }> ();

    selectedBanner: any = null;

    generalSectionTypes = SectionNavModel;

    onSelect(type: string, subType?: string) {
        if(type && subType){
            return this.openType.emit({ type, subType });
        }
        this.selectedBanner = this.generalSectionTypes.find((item)=> item.type === type)?.components;
        if(this.selectedBanner.length === 0){
            subType = type;
            this.selectedBanner = null;
        }
        this.openType.emit({ type, subType });
    }

}
